export const DATE_FORMAT = 'dd/MM/yyyy';
export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_LINES_PAGE_SIZE = 50;
export const TOAST_DURATION = 5000; //in milliseconds
export const TOAST_PERMANENT = 0;
export const TOAST_ERROR_DURATION = 8000; // errors stay a bit longer, but never forever
export const TOAST_NETWORK_DURATION = 10000; // network/server outages: give the user time to read
export const TOAST_DEDUP_WINDOW = 1200; // suppress identical toasts fired within this window (ms)
export const TOAST_ERP_ERROR_DURATION = 20000; // long ERP rejections need reading time
export const ERP_ERROR_LONG_THRESHOLD = 200; // chars; above this the ERP toast lingers
export const DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm';
export const PAGE_SIZE_OPTIONS = [25, 50, 100];

